module.exports = __webpack_public_path__ + "img/1919.a9115204.jpg";